import { P0, S, abs, arc, fillAt, max, rotPts } from '../../geometry';

export const lamp = {
  name: 'Lamp',
  colors: ['#161616', '#E3A008'],
  draw(m, t) {
    let swing = 4 * S(t * 1.2),
      beam = 0.55 + 0.1 * S(t * 2),
      lift = 0,
      spread = 1,
      pose = P0();
    if (m === 'happy') {
      swing = 12 * S(t * 6);
      beam = 1;
      lift = -2 * abs(S(t * 6));
      spread = 1.15;
    }
    // Thinking: swings like a pendulum, its light sweeping the floor.
    if (m === 'thinking') {
      swing = 16 * S(t * 2);
      beam = 0.9;
    }
    if (m === 'talking') {
      beam = 0.5 + 0.5 * max(0, S(t * 10));
      swing = 3 * S(t * 3);
    }
    if (m === 'surprised') {
      lift = -5;
      beam = 1;
      spread = 1.3;
      swing = S(t * 26);
    }
    if (m === 'paused') {
      beam = 0;
      swing = 1.5 * S(t * 0.6);
      lift = 2;
    }
    const rot = (pts) =>
      rotPts(
        pts.map(([x, y]) => [x, y + lift]),
        50,
        2,
        swing
      );
    const cord = rot([
        [50, 2],
        [50, 26],
      ]),
      shade = rot(arc(50, 50, 25, 180, 360, 13)),
      rim = rot([
        [22, 50],
        [78, 50],
      ]);
    const rays = [-1, 0, 1].map((k) => ({
      c: 'b',
      pts: rot([
        [50 + k * 12, 57],
        [50 + k * 19 * spread, 69],
      ]),
      o: beam,
      detail: true,
    }));
    const eye = rot([[50, 40]])[0];
    return {
      strokes: [
        { c: 'a', pts: cord },
        { c: 'a', pts: shade, n: 16 },
        { c: 'a', pts: rim },
        ...rays,
      ],
      eyes: { x: eye[0], y: eye[1] },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 1),
};
